import _cloneDeep from "lodash/cloneDeep";

export default {
  namespaced: true,
  state: {
    enable_backup: true,
    backup_keys: [
      "layout_mode",
      "menu_mode",
      "sentence_mode",
      "memo_mode",
      "tabs",
      "font_size",
      "search_target",
      "search_string",
      "replace_string",
      "search_filtering",
      "search_case_sensitive",
      "filter_memo_exists"
    ],
    backup_content_keys: [
      "content_mode",
      "content_id",
      "content_name",
      "content",
      "content_original",
      "content_modified",
      "filter_status",
      "history",
      "history_index"
    ],
    layout_mode: "vertical",  // "horizontal" or "vertical"
    menu_mode: "icon",  // "icon" or "menu"
    sentence_mode: "horizontal",  // "horizontal" or "vertical"
    content_mode: "translated", // "source", "translated", "corpus", "term"
    memo_mode: false,
    tabs: [],
    select_tab: null,
    backup_side_menu: null,
    font_size: 0.875,
    search_target: "source",
    search_string: "",
    replace_string: "",
    search_filtering: false,
    search_case_sensitive: false,
    search_field: null,
    filter_memo_exists: false,
    history_limit: 20,
    shortcut: {
      unshift: {},
      shift: {}
    },
    select_text: ""
  },
  getters: {
    backup_keys: state => {
      return state.backup_keys;
    },
    backup_content_keys: state => {
      return state.backup_content_keys;
    },
    layout_mode: state => {
      return state.layout_mode;
    },
    menu_mode: state => {
      return state.menu_mode;
    },
    sentence_mode: state => {
      return state.sentence_mode;
    },
    memo_mode: state => {
      return state.memo_mode;
    },
    tabs: state => {
      return state.tabs;
    },
    select_tab: state => {
      return state.select_tab;
    },
    backup_side_menu: state => {
      return state.backup_side_menu;
    },
    font_size: state => {
      return state.font_size;
    },
    search_target: state => {
      return state.search_target;
    },
    search_string: state => {
      return state.search_string;
    },
    replace_string: state => {
      return state.replace_string;
    },
    search_filtering: state => {
      return state.search_filtering;
    },
    search_case_sensitive: state => {
      return state.search_case_sensitive;
    },
    search_field: state => {
      return state.search_field;
    },
    filter_memo_exists: state => {
      return state.filter_memo_exists;
    },
    history_limit: state => {
      return state.history_limit;
    },
    shortcut: state => {
      return state.shortcut;
    },
    select_text: state => {
      return state.select_text;
    },
  },
  mutations: {
    setEditor(state, backup){
      for(var key of state.backup_keys){
        state[key] = backup[key];
      }
    },
    setEnableBackup(state, enable_backup){
      state.enable_backup = enable_backup;
    },
    setLayoutMode(state, layout_mode){
      state.layout_mode = layout_mode;
    },
    setMenuMode(state, menu_mode){
      state.menu_mode = menu_mode;
    },
    setSentenceMode(state, sentence_mode){
      state.sentence_mode = sentence_mode;
    },
    setMemoMode(state, memo_mode){
      state.memo_mode = memo_mode;
    },
    setTabs(state, tabs){
      state.tabs = tabs;
    },
    setSelectTab(state, select_tab){
      state.select_tab = select_tab;
    },
    setBackupSideMenu(state, backup_side_menu){
      state.backup_side_menu = backup_side_menu;
    },
    setFontSize(state, font_size){
      if(font_size >= 0.625 && font_size <= 1.5){
        state.font_size = font_size;
      }
    },
    setSearchTarget(state, search_target){
      state.search_target = search_target;
    },
    setSearchString(state, search_string){
      state.search_string = search_string;
    },
    setReplaceString(state, replace_string){
      state.replace_string = replace_string;
    },
    setSearchFiltering(state, search_filtering){
      state.search_filtering = search_filtering;
    },
    setSearchCaseSensitive(state, search_case_sensitive){
      state.search_case_sensitive = search_case_sensitive;
    },
    setSearchField(state, search_field){
      state.search_field = search_field;
    },
    setFilterMemoExists(state, filter_memo_exists){
      state.filter_memo_exists = filter_memo_exists;
    },
    setHistoryLimit(state, history_limit){
      state.history_limit = history_limit;
    },
    setShortcut(state, shortcut){
      var result = {
        unshift: {},
        shift: {}
      };
      for(var key in shortcut){
        if(shortcut[key].key === ""){
          continue;
        }
        var key_names = [];
        if(["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"].indexOf(shortcut[key].key) >= 0){
          key_names.push("Digit" + shortcut[key].key);
          key_names.push("Numpad" + shortcut[key].key);
        }else{
          key_names.push("Key" + shortcut[key].key);
        }
        for(var key_name of key_names){
          if(shortcut[key].shift){
            result.shift[key_name] = key;
          }else{
            result.unshift[key_name] = key;
          }
        }
      }
      state.shortcut = result;
    },
    setSelectText(state, select_text){
      state.select_text = select_text;
    }
  },
}
